const TabsSchema = () => ({
  title: 'AgSUS Tabs',
  fieldsets: [
    { id: 'default', title: 'Geral', fields: ['eyebrow', 'title', 'orientation'] },
  ],
  properties: {
    eyebrow: {
      title: 'Etiqueta',
      description: 'Texto curto em caixa alta, acima do título.',
    },
    title: {
      title: 'Título da seção',
      description: 'Opcional.',
    },
    orientation: {
      title: 'Orientação',
      description:
        'Horizontal (padrão) usa abas em linha. Vertical usa lista lateral à esquerda com painel à direita (estilo "Estrutura e instâncias deliberativas").',
      choices: [
        ['horizontal', 'Horizontal (padrão)'],
        ['vertical', 'Vertical (sidebar)'],
      ],
      default: 'horizontal',
    },
  },
  required: [],
});

export default TabsSchema;
